import React from 'react';

const DailyInsights: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <p className="text-slate-500 dark:text-slate-400 text-sm">Coming Soon</p>
    </div>
  );
};

export default DailyInsights;
